import { useView } from '@10000/react'
import { InputScreen, useShell, useStack } from '../layout'
import { SelectableList } from '../forms'
import { Box } from '../widgets'
import { SelectTeam } from '.'

export const SelectOrganisation = ({ active }) => {
  const { push } = useStack()
  const { myOrganisations } = useView('tenant')
  useShell({ active, mode: 'navigate' })

  const organisationSelected = ({ organisation }) => organisation !== undefined && push(SelectTeam, { props: { organisationId: myOrganisations[organisation].id } })

  return (
    <InputScreen centered onSubmit={organisationSelected} footerButton="Select" title="Select Organisation">
      <Box className="scrolling-list">
        <SelectableList
          name="organisation"
          list={myOrganisations.map(x => x.name)}
        />
      </Box>
    </InputScreen>
  )
}